import CarouselSection from "./CarouselSection";

const ResearchAndDevelopment = () => {
  const images = [
    "/img/reasearch_and_development/1.png",
    "/img/reasearch_and_development/2.png",
    "/img/reasearch_and_development/3.png",
    "/img/reasearch_and_development/4.png",
    "/img/reasearch_and_development/5.png",
  ];

  const description = `We are deeply committed to persistent, purpose-driven research, which forms a core pillar of our mission. Our fully equipped, independent in-house R&D center, supported by a pilot plant, is designed to handle a wide range of probiotics and biotech molecules. The facility is led by a skilled team of microbiology and biotechnology experts, along with external specialists from various application areas.`;

  const popupParagraphs = [
    `We are deeply committed to persistent, purpose-driven research, which forms a core pillar of our mission. Our fully equipped, independent in-house R&D center, supported by a pilot plant, is designed to handle a wide range of probiotics and biotech molecules. The facility is led by a skilled team of microbiology and biotechnology experts, along with external specialists from various application areas.`,
    `Our R&D efforts focus on enhancing existing product lines through new strain identification, characterization, and host response studies. We explore probiotic action mechanisms, synergies between strains, and innovations in formulation, dosing, and delivery. We also work on improving yields and discovering new application areas where probiotics can offer clear benefits.`,
    `Beyond probiotics, we are focused on the development of next-generation biotech products such as nutraceuticals, biotherapeutics, and peptides. From research and pilot-scale production to commercialization, our R&D pipeline is driven by customer needs and aligned with our vision of advancing sustainable and effective biotech solutions.`,
  ];

  return (
    <CarouselSection
      title="Research & Development"
      description={description}
      popupTitle="Research & Development"
      popupParagraphs={popupParagraphs}
      images={images}
    />
  );
};

export default ResearchAndDevelopment;
